import { render, staticRenderFns } from "./EditorButtonGroup.vue?vue&type=template&id=0dce3e37&scoped=true"
import script from "./EditorButtonGroup.vue?vue&type=script&lang=js"
export * from "./EditorButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./EditorButtonGroup.vue?vue&type=style&index=0&id=0dce3e37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce3e37",
  null
  
)

export default component.exports